module.exports = __webpack_public_path__ + "img/x431_4.7eab2aef.jpg";